














import Vue from 'vue'
import Home from './views/Home.vue'

export default Vue.extend({
  name: 'App',

  components: {
    Home
  },
  mounted (): void {
    document.title = '大学生のための時間割'
  }
})
